import React from "react";
import { MenuItem, FormControl, Select, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 110,
    },
    menuItemScroll: {
        maxHeight: "200px",
        overflowY: "auto",
    },
}));

export const OrderHistorySorting = ({
    language,
    sorting,
    setSorting,
}) => {
    const classes = useStyles();

    return (
        <div className="sorting">
            <FormControl className={classes.formControl}>
                <Select
                    MenuProps={{
                        classes: {
                            paper: classes.menuItemScroll,
                        },
                    }}
                    variant="outlined"
                    margin="dense"
                    onChange={(e) => setSorting(e.target.value)}
                    value={sorting || ""}
                    displayEmpty
                >
                    <MenuItem className="sorting-menu" value="" disabled>
                        {language.CCMODE_THEME1_GRID_SORTBY}
                    </MenuItem>
                    <MenuItem className="sorting-menu" value="created_desc">
                        Newest
                    </MenuItem>
                    <MenuItem className="sorting-menu" value="created_asc">
                        Oldest
                    </MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};